import { useEffect, useState } from "react";
import api, { apiError } from "../../lib/api";
import { fmtDateTime } from "../../lib/format";
import AppLayout, { PageLoader, EmptyState, thCls, tdCls, rowCls } from "../../components/AppLayout";
import { Badge } from "../../components/ui/badge";

const actionBadge = (a) => {
  const map = {
    login: "bg-sky-500/10 text-sky-300 border-sky-500/25",
    update: "bg-amber-500/10 text-amber-300 border-amber-500/25",
    update_kyc: "bg-amber-500/10 text-amber-300 border-amber-500/25",
    create: "bg-emerald-500/10 text-emerald-300 border-emerald-500/25",
    upload: "bg-emerald-500/10 text-emerald-300 border-emerald-500/25",
    download: "bg-white/5 text-zinc-400 border-white/10",
    delete: "bg-red-500/10 text-red-400 border-red-500/25",
    view: "bg-white/5 text-zinc-400 border-white/10",
  };
  return map[a] || map.view;
};

export default function AdminAudit() {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/admin/audit-logs").then((r) => setRows(r.data)).catch((e) => setError(apiError(e)));
  }, []);

  if (error) return <AppLayout title="Audit Logs"><p className="text-red-400 text-sm">{error}</p></AppLayout>;
  if (!rows) return <AppLayout title="Audit Logs"><PageLoader /></AppLayout>;

  return (
    <AppLayout title="Audit Logs" subtitle="Sensitive actions recorded across the platform with old and new values.">
      <div className="glass-card overflow-hidden fade-up">
        {rows.length === 0 ? <EmptyState message="No audit activity yet." /> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="audit-table">
              <thead>
                <tr className="border-b border-white/[0.06]">
                  <th className={thCls}>Timestamp</th>
                  <th className={thCls}>Actor</th>
                  <th className={thCls}>Action</th>
                  <th className={thCls}>Entity</th>
                  <th className={thCls}>Details</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id} className={rowCls}>
                    <td className={`${tdCls} tnum text-xs text-zinc-400 whitespace-nowrap`}>{fmtDateTime(r.timestamp)}</td>
                    <td className={tdCls}>
                      <p className="text-xs font-medium text-zinc-200">{r.actor_email}</p>
                      <p className="text-[9px] uppercase tracking-[0.16em] text-zinc-600">{r.actor_role}</p>
                    </td>
                    <td className={tdCls}>
                      <Badge variant="outline" className={`text-[10px] ${actionBadge(r.action)}`}>{r.action}</Badge>
                    </td>
                    <td className={`${tdCls} text-xs text-zinc-400`}>{r.entity}</td>
                    <td className={`${tdCls} text-[11px] text-zinc-500 max-w-md`}>
                      {(r.details?.changes || []).map((c, i) => (
                        <div key={i} className="truncate">
                          <span className="text-zinc-300">{c.field}</span>: {JSON.stringify(c.old) ?? "—"} → {JSON.stringify(c.new)}
                        </div>
                      )) || <span className="truncate block">{JSON.stringify(r.details)}</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </AppLayout>
  );
}
